/* Let keyboard users scroll wide editorial tables without changing table semantics. */
(() => {
  const tables = document.querySelectorAll('.joyo-standard-page table');
  if (!tables.length) return;
  const update = () => tables.forEach(table => {
    if (table.scrollWidth > table.clientWidth + 1) table.setAttribute('tabindex', '0');
    else table.removeAttribute('tabindex');
  });
  update();
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(update);
    tables.forEach(table => observer.observe(table));
  } else window.addEventListener('resize', update, { passive: true });
})();
